import { render } from "./CustomCoordinate.vue?vue&type=template&id=7d43c78d"
import script from "./CustomCoordinate.vue?vue&type=script&lang=js"
export * from "./CustomCoordinate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__